import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API } from '@core/services/api.base';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  BusinessInformationEntity,
  ZipCodeEntity,
} from 'src/app/models/business.model';

export interface NearbyBusinessesResponse {
  businessInformationEntities: BusinessInformationEntity[];
  lastDocumentId: string | null;
  hasMore: boolean;
}

export interface NearbyBusinessesPaginatedResponse {
  businessInformationEntities: BusinessInformationEntity[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
  hasMore: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class BusinessService extends API {
  getZipCodeInfo(zipCode: string): Observable<ZipCodeEntity> {
    return this.get<ZipCodeEntity>(`v1/zip-code/${zipCode}`);
  }
  findById(id: string): Observable<BusinessInformationEntity> {
    return this.get<BusinessInformationEntity>(
      `v1/business-information/detail/${id}`
    );
  }

  getNearbyBusinesses(
    latitude: number,
    longitude: number,
    radiusInKilometers: number = 10,
    type: string | null = null,
    lastDocumentId: string | null = null,
    limit: number | null = null
  ): Observable<NearbyBusinessesResponse> {
    let url = `v1/business-information/nearby?latitude=${latitude}&longitude=${longitude}&radiusInKilometers=${radiusInKilometers}`;
    if (type) {
      url += `&type=${type}`;
    }
    if (lastDocumentId) {
      url += `&lastDocumentId=${lastDocumentId}`;
    }
    if (limit !== null) {
      url += `&limit=${limit}`;
    }
    return this.get<NearbyBusinessesResponse>(url);
  }

  getNearbyBusinessesPaginated(
    latitude: number,
    longitude: number,
    radiusInKilometers: number = 10,
    type: string | null = null,
    pageNumber: number = 1,
    limit: number = 6
  ): Observable<NearbyBusinessesPaginatedResponse> {
    let url = `v1/business-information/nearby/paginated?latitude=${latitude}&longitude=${longitude}&radiusInKilometers=${radiusInKilometers}&pageNumber=${pageNumber}&limit=${limit}`;
    if (type) {
      url += `&type=${type}`;
    }
    return this.get<NearbyBusinessesPaginatedResponse>(url);
  }

  searchBusinesses(
    query: string,
    page: number = 0,
    latitude?: number,
    longitude?: number,
    radiusInKm?: number
  ): Observable<{
    hits: BusinessInformationEntity[];
    page: number;
    nbPages: number;
    nbHits: number;
  }> {
    let url = `v1/business-information/search?query=${encodeURIComponent(
      query
    )}&page=${page}`;
    if (latitude !== undefined && longitude !== undefined) {
      url += `&latitude=${latitude}&longitude=${longitude}`;
    }
    if (radiusInKm !== undefined) {
      url += `&radiusInKm=${radiusInKm}`;
    }
    return this.get<{
      hits: BusinessInformationEntity[];
      page: number;
      nbPages: number;
      nbHits: number;
    }>(url);
  }
}
